/* ============================================================
   Google AdSense configuration
   ============================================================
   Replace PUBLISHER_ID below with your real ID after approval.
   It looks like "ca-pub-1234567890123456".
   
   Each ad placement on the site uses a "slot ID" — those are 
   created inside the AdSense dashboard. Generally easier to 
   enable "Auto ads" in AdSense and let Google place ads, but 
   we also have manual slots for fine control.
   
   While PUBLISHER_ID is the placeholder, no ads load and the 
   AdSlot components render nothing in production (small dashed 
   placeholders in dev mode so you can see where ads will go).
   ============================================================ */

export const PUBLISHER_ID = "ca-pub-XXXXXXXXXXXXXXXX"; // TODO: replace after AdSense approval

// Individual slot IDs (created in AdSense dashboard once approved)
export const AD_SLOTS = {
  homeMid: "XXXXXXXXXX",
  guideInArticle: "XXXXXXXXXX",
  calcResult: "XXXXXXXXXX",
};

export function isAdSenseEnabled() {
  return (
    PUBLISHER_ID !== "ca-pub-XXXXXXXXXXXXXXXX" &&
    PUBLISHER_ID.startsWith("ca-pub-")
  );
}
